import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "api";
import { proceedThunk } from "./utils";

export const recordingsListThunk = createAsyncThunk(
  "recording/original/list",
  proceedThunk(api.takebaker.recordings.originalsList)
);

export const createRecordingThunk = createAsyncThunk(
  "recording/original/create",
  proceedThunk(api.takebaker.recordings.create)
);

export const createRecordingTTSThunk = createAsyncThunk(
  "recording/original/createTTS",
  proceedThunk(api.takebaker.recordings.createTTS)
);

export const conversionOrderThunk = createAsyncThunk(
  "recording/conversion/order",
  proceedThunk(api.takebaker.recordings.order)
);

export const updateRecordingThunk = createAsyncThunk(
  "recording/update",
  proceedThunk(api.takebaker.recordings.update)
);

export const deleteRecordingThunk = createAsyncThunk(
  "recording/delete",
  proceedThunk(api.takebaker.recordings.delete)
);

export const exportTakeThunk = createAsyncThunk(
  "recording/export",
  async (payload, { rejectWithValue }) => {
    const response = await api.takebaker.recordings.export(payload);
    if (!response.ok) {
      const body = await response.json();
      return rejectWithValue(body);
    }

    const contentDisposition = response.headers.get("content-disposition");
    const filenameIndex =
      contentDisposition.indexOf(`filename=`) + "filename=".length;
    const filename = contentDisposition.substr(filenameIndex);

    return { filename, blob: await response.blob() };
  }
);

export const conversionRedoThunk = createAsyncThunk(
  "recording/conversion/redo",
  proceedThunk(api.takebaker.recordings.redo)
);

export const conversionsListThunk = createAsyncThunk(
  "recording/conversion/list",
  proceedThunk(api.takebaker.recordings.conversionsList)
);

export const fetchRecordingThunk = createAsyncThunk(
  "recording/get",
  proceedThunk(api.takebaker.recordings.get)
);

export const conversionCountThunk = createAsyncThunk(
  "recording/conversionCount",
  proceedThunk(api.takebaker.recordings.conversionCount)
);

export const reportConversionIssueThunk = createAsyncThunk(
  "auth/reportConversionIssue",
  proceedThunk(api.takebaker.recordings.reportConversionIssue)
);
